import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackEvent, EVENTS } from "@/lib/analytics";

/**
 * Drop this component once inside <BrowserRouter> to auto-track page views.
 */
export function AnalyticsPageTracker() {
  const location = useLocation();

  useEffect(() => {
    trackEvent(EVENTS.PAGE_VIEW, { path: location.pathname });
  }, [location.pathname]);

  return null;
}
